module.exports = ".container{\r\n    margin-top: 50px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/bikes/bikes.component.css
// module id = ./src/app/Components/bikes/bikes.component.css
// module chunks = main